import React, { useState, useEffect } from 'react'
import { useRequest } from '../utils/hooks'
import { withRouter } from 'react-router-dom'
import { getAtendendoComo } from '../utils/atendendo_como'
import BaseDialog from '../components/general/BaseDialog'
import DialogEstabelecimentoComponent from '../components/DialogEstabelecimentoComponent'

const DialogEstabelecimento = ({ history, dialog, setDialog, pageProps }) => {
  const urlParams = new URLSearchParams(window.location.search)
  const [
    dialogEstabelecimentoReported,
    setDialogEstabelecimentoReported,
  ] = useState({
    isOpen: false,
    data: { estabelecimento: '' },
  })

  const [, , reportEstabelecimento] = useRequest(
    [],
    {
      url: `estabelecimentos/denunciar`,
      method: 'get',
      params: {
        id: dialog.data ? dialog.data.id : '',
      },
    },
    null,
    {
      onComplete: (data) => {
        setDialogEstabelecimentoReported({
          isOpen: true,
          data: { estabelecimento: dialog.data.estabelecimento },
        })
      },
    }
  )

  useEffect(() => {
    if (dialog.isOpen && !urlParams.get('estabelecimento')) {
      history.push(`?estabelecimento=${dialog.data.id}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dialog])

  const handleClose = () => {
    setDialog({ isOpen: false, data: null })
    history.push(pageProps.url)
  }

  return (
    dialog.data && (
      <>
        <BaseDialog
          dialog={dialog}
          setDialog={setDialog}
          title={dialog.data.nome}
          description={
            <>
              <span>
                {(dialog.data.categoria && dialog.data.categoria.nome) || ''}
              </span>{' '}
              {(dialog.data.categoria &&
                dialog.data.categoria.nome &&
                dialog.data.atendendo_como &&
                ' • ') ||
                ''}
              <span>{getAtendendoComo(dialog.data.atendendo_como)}</span>
            </>
          }
          actionTitle={''}
          handleAction={() => {}}
          slug={'estabelecimento'}
          fullWidth={true}
          maxWidth={'sm'}
          onClose={handleClose}
        >
          <DialogEstabelecimentoComponent
            dialog={dialog}
            pageProps={pageProps}
            reportEstabelecimento={reportEstabelecimento}
          />
        </BaseDialog>
        <BaseDialog
          dialog={dialogEstabelecimentoReported}
          setDialog={setDialogEstabelecimentoReported}
          title={'Estabelecimento reportado'}
          description={`O estabelecimento foi encaminhado para análise. Caso o material seja considerado inapropriado, ele será retirado do ar.`}
          actionTitle={'Ok, estou ciente'}
          handleAction={() =>
            setDialogEstabelecimentoReported({ isOpen: false, data: null })
          }
          slug={'denunciar'}
          fullWidth={true}
          maxWidth={'xs'}
        ></BaseDialog>
      </>
    )
  )
}

export default withRouter(DialogEstabelecimento)
